<template>
  <div class="container">
  <div class="columns is-centered">
    <div class="column is-three-quarters-desktop">

<h1 class="subtitle is-4 has-text-centered">
  Token Bridge 
</h1>



<article class="message">
  <div class="message-body">
    <span class="icon has-text-info">
     <i class="fas fa-info-circle"></i>
    </span>
    Supported networks: all EVM Chains., Get some add test network 
    <a
      href="https://twitter.com/wizardbridgeevm"
      target="_blank"
    >here</a>
  </div>
</article>

<div class="columns is-multiline">
  <div class="column is-half">
    <div class="field">
      <label class="label">From 
        <span style="color: rgb(141, 130, 130); font-style: italic; opacity: 0.5; font-size: 80%;" >
          (switch networks with metamask)</span></label>
      <div class="control">
        <div class="control" data-tooltip="Switch networks with Metamask">
          <input
            class="input"
            type="text"
            :value="fromChainData.name"
            disabled
          >
        </div>
      </div>
    </div>
  </div>

  
  
  <div class="column is-half">
    <div class="field">
      <label class="label">To  
        <span v-if="!toChainId || toChainId === -2" class="has-text-danger" style="font-size: 80%; font-style: italic; ">
          <i><b>* Please select network. </b>
            <a href="https://wizard-bridge-evm.gitbook.io/docs/product-guides/add-networks" target="_blank" rel="noopener noreferrer">
              add network</a> 
          </i> 
        </span>
      </label>

      <div class="control">
        <div class="select is-fullwidth ">
          <select v-model="toChainId">
            <option
              disabled
              value="-2"
            >
              <!-- Please select one. -->
              Please select one or type to search.
            </option>
            <option
              v-for="(chain, key) in supportedChains"
              :key="key"
              :value="chain.chainId"
            >
             {{ chain.name }} <span>/ {{ chain.chainId }}</span>
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="field">
  <label class="label">Token
    <span v-if="!selectedToken || selectedToken === -2" class="has-text-danger" style="font-size: 80%; font-style: italic; ">
     <i><b>* Please select token. </b>
      <router-link to="/import">import</router-link> 
      <!-- / <router-link to="/interface">interface</router-link> -->
     </i> 
    </span>
  </label>

  <div class="control">
    <div class="select is-fullwidth">
      <select
        v-model="selectedToken"
        @change="getBalance"
      >
        <option
          disabled
          value=""
        >
        Add the tokens you want to bridge on the "Import" page.
        <!-- Tokens must be added by importing first on the import page. -->
        </option>
        <option
          v-for="(token, key) in tokens"
          :key="key"
          :value="token"
        >
          {{ token.symbol }} <span> / {{ token.address.substring(0, 5) }}...{{ token.address.slice(-4) }} / {{ token.sourceChainId }}</span>
        </option>
      </select>
    </div>
  </div>
</div>


<div class="field">
  <label class="label">Amount
    <span class="tag is-info is-light is-pulled-right">Balance: {{ selectedBalance }}</span>
    <span v-if="!amount" class="has-text-danger" style="font-size: 80%; font-style: italic; ">
      <!-- <i><b>* Please enter quantity in numbers. </b> -->
      <i><b>* Please enter numbers. </b>
       <a href="https://" target="_blank" rel="noopener noreferrer"></a> 
      </i> 
    </span>
  </label>

  <div class="control">
    <input 
      v-model="amount"
      class="input"
      type="text"
      placeholder="0.1"
    >
  </div> 
</div>
<!-- <span class="tag is-info is-light is-pulled-left">Balance: {{ selectedBalance }}</span> -->


<div class="field">
<!-- Add a ref to the modal -->
<div class="modal" :class="{ 'is-active': isConfirmationModalOpen }">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <b class="modal-card-title">Confirmation ✅</b>
    </header>
    <section class="modal-card-body">
      <p>Please confirm your action:</p>
      <ul>
        <li style="font-size: 80%;">-- Section: Token Bridge (2 Txns) --</li>
        <li>1.1 <b>GAS FEE! to Bridge:</b> Source network (From)</li>
        <li>1.2 <b>GAS + FEE! for Bridge:</b> 0.001 Native coin</li>
        <li style="font-size: 80%;">-- Section: Claim Bridged Tokens (1 Txns) --</li>
        <li>2. <b>GAS FEE! to Claim:</b> Destination network (To)</li>
        <!-- <li>3.xxx</li> -->
        <br>
        <br>
         <i>Note: Prepare the cost of gas and Add the destination network first. 
          <a
           href="https://wizard-bridge-evm.gitbook.io/docs/product-guides/add-networks"
           target="_blank"
          >here</a>
         </i>
      </ul>
    </section>
    <footer class="modal-card-foot is-justify-content-flex-end">
      <!-- Confirm -->
      <button class="button is-success" @click="confirmLockOrBurn">Bridge</button> 
      <button class="button" @click="closeConfirmationModal">Cancel</button>
    </footer>
  </div>
</div>

<!-- Modify the button to open the confirmation modal -->
<div class="field">
  <div class="control has-text-right">
    <button
      class="button is-link"
      @click="openConfirmationModal"
      :disabled="buttonClicked"
    >
      Next
    </button>
  </div>
</div>
</div>



<div class="message  -body" v-if="notificationMessage">
<article class="message is-danger">
  <div class="message-header">
    <p>Warning</p>
  </div>
  <!-- {{ notificationMessage }} -->
  👇 Please get your rights completed. to the destination chain Before going up the new bridge, <br>
 <b><a href="https://wizard-bridge-evm.gitbook.io/docs/product-guides/getting-use-up"
       target="_blank">
 Limitations and cautions</a></b> <br> 
 1 - Do not refresh the web page <br>
 2 - Cannot recover data or view <br>
 3 - Claim only once. 
</article>
</div>


<br>


<div class="claim-bridged-tokens">
  <div class="has-text-centered">
   <h1 class="subtitle is-4 has-text-centered"   ref="claimBridgedTokensSection">
    <!-- Claim Bridged Tokens -->
    Claim Bridged Tokens
   </h1>
   <!-- <p class="top " style="font-size: 80%;">(Show all, Please claim your address.)</p> -->
   <p class="top " style="font-size: 80%;">(Please claim your address.)</p>
  </div>
  <br>
<article class="message">
  <div class="message-body">
    <span class="icon has-text-warning">
     <i class="fas fa-exclamation-triangle"></i>
    </span>
    Warning!: When you start a brige, the page should not be refreshed. until the claim is successful. (It cannot be recovered / please check before confirm)
    <!-- <a
      href="https://faucets.chain.link/rinkeby"
      target="_blank"
    >here</a>. -->
  </div>
</article>
  <div class="table-container">
    <table class="table is-fullwidth">
  <thead>
    <tr>
      <th>Action</th>
      <th class="th-light-up">Receiver </th>
      <th>From</th>
      <th>To</th>
      <th>Symbol</th>
      <th>Token</th>
      <th>Amount</th>
    </tr>
  </thead>
  
  <tbody>
  <template v-for="(t, key) in claims" :key="key">
    <tr v-if="isCurrentUserAccount(t.receiver)">
      <template v-if="web3">
        <button
          v-if="!claimedClaims.includes(key)"
          :class="[
            'button', 
            'is-link', 
            'is-small', 
            'effect',
            chainId == t.sourceChain ? 'switch' : 'claim',
            { 'active': isButtonActive(key) }
          ]"
          @click="mintOrRelease(key)"
        >
          {{ chainId == t.sourceChain ? 'Switch' : 'Claim' }}
        </button>
        <span v-else class="tag is-orange"><b>Success</b></span>
      </template>
      <td>{{ t.receiver.substring(0, 5) }}...{{ t.receiver.slice(-4) }}</td>
      <td>{{ t.sourceChain }}</td>
      <td>{{ t.targetChain }}</td>
      <td>{{ t.wrappedTokenSymbol }}</td>
      <td>{{ t.token.substring(0, 5) }}...{{ t.token.slice(-4) }}</td>
      <td>{{ t.amount }}</td>
    </tr>
  </template>
</tbody>


  
</table>
</div>


</div>

<!-- <h1>Deposit</h1>
<div class="field">
  <div class="control has-text-right">
         <button
          v-if="!claimedClaims.includes(key)"
          class="button is-link is-small"
          @click="mintOrRelease(key)"
        >
          {{ chainId == t.sourceChain ? 'Swtich' : 'Claim' }}
        </button>
  </div>
</div>
<br> -->

<!-- Add this at the end of your template -->
<div class="modal" :class="{ 'is-active': isClaimSuccessModalOpen }">
<div class="modal-background"></div>
<div class="modal-card">
  <header class="modal-card-head">
    <b class="modal-card-title">Completed 🎉</b>
  </header>
  <section class="modal-card-body">
    <p>Congratulations! Your bridge has been success.
      <br>
    <i>(Please check the latest transaction in Metamask)</i></p>
    <br>
    <b>Source network transactions: </b>
    <br>
    <b>Destination network transactions: </b>
    <br>
    <br>
    <br>
    <i>Note: Can now be refreshed to start a new bridge. and connecting the wallet again.</i>
  </section>
  <footer class="modal-card-foot is-justify-content-flex-end">
    <button class="button is-success " @click="refreshPage">OK</button>
  </footer>
</div>
</div>

   </div>
  </div>
</div>

</template>

<script>
import { mapState } from 'vuex'
import loader from '@/mixins/loader'
import utilities from '@/mixins/utilities'
import { getChainData } from '@/constants/chains'
import WalletService from '@/services/wallet'
import BridgeService from '@/services/bridge'
import { ethers } from 'ethers'
import '@/styles.css';

import Web3 from 'web3';

const dataInitialState = function () {
return {
  fromChainData: {},
  claimedClaims: [],
  supportedChains: [
    // { name: 'Goerli', chainId: 5 },
    { name: 'Sepolia', chainId: 11155111 },
    { name: 'Holesky', chainId: 17000 },
    // { name: 'Mumbai - Testnet', chainId: 80001 },
    { name: 'Amoy - Testnet', chainId: 80002 },
    { name: 'BNB Smart Chain - Testnet', chainId: 97 },
    // { name: 'Arbitrum Goerli - Testnet', chainId: 421613 },
    { name: 'Arbitrum Seploia - Testnet', chainId: 421614 },
    // { name: 'Optimism Goerli - Testnet', chainId: 420 },
    { name: 'Optimism Sepolia - Testnet', chainId: 11155420 },
    // { name: 'Base Goerli - Testnet', chainId: 84531 },
    { name: 'Base Sepolia - Testnet', chainId: 84532 },
    { name: 'Linea - Testnet', chainId: 59140 },
    { name: 'Avalanche Fuji - Testnet', chainId: 43113 },
    { name: 'Fantom - Testnet', chainId: 4002 },
    { name: 'Bitkub Chain - Testnet', chainId: 25925 },
    { name: 'Flare - Testnet Coston', chainId: 16 },
    { name: 'Public Goods Network - Testnet', chainId: 58008 },
    { name: 'Haqq Chain - Testnet', chainId: 54211 },
    { name: 'Lightlink - Testnet Pegasus', chainId: 1891 },
    { name: 'Taiko - Testnet Jolnir L2', chainId: 167007 },
    { name: 'Mode - Testnet', chainId: 919 },
    { name: 'Neo EVM - Testnet', chainId: 2970385 },
    { name: 'ZetaChain - Testnet Athens 3', chainId: 7001 },
    { name: 'Scroll - Testnet Sepolia', chainId: 534351 },
    { name: 'Mantle - Testnet', chainId: 5001 },
    { name: 'opBNB - Testnet', chainId: 5611 },
    { name: 'Omni Network - Testnet', chainId: 165 },
    { name: 'Manta Pacific - Testnet', chainId: 3441005 },
    { name: 'Kroma - Testnet Sepolia', chainId: 2358 },
    { name: 'Polygon zkEVM - Testnet', chainId: 1442 },
    { name: 'Shardeum Sphinx 1.X - Testnet Dapp', chainId: 8081 },
    { name: 'X1 (OKX L2) - Testnet', chainId: 195 },
    { name: 'Arbitrum Stylus - Testnet', chainId: 23011913 },
    { name: 'Frame - Testnet', chainId: 68840142 },
    { name: 'zKatana - Testnet', chainId: 1261120 },
    { name: 'Redstone - Testnet', chainId: 17001 },
    { name: 'Gnosis - Testnet Chiado', chainId: 10200 },
    { name: 'Zora Sepolia - Testnet', chainId: 999999999 },
    { name: 'Blast Sepolia - Testnet', chainId: 168587773 },
    { name: 'Taiko Katla - Testnet', chainId: 167008 },
    { name: 'Berachain Artio - Testnet', chainId: 80085 },
    { name: 'Tabichain 1.0 - Testnet', chainId: 9789 },
    { name: 'Taiko - Testnet Hekla L2', chainId: 167009 },
    { name: 'ALIENX Hal - Testnet', chainId: 10241025 },
    { name: 'Sei - Testnet', chainId: 1328 },
    { name: 'Soneium - Minato', chainId: 1946 },
    { name: 'Story - Testnet', chainId: 1513 },
    { name: 'Hemi - Sepolia', chainId: 743111 },
    { name: 'Kaia Kairos - Testnet', chainId: 1001 },
    { name: 'Unichain Sepolia - Testnet', chainId: 1301 },
    { name: 'Superposition - Testnet', chainId: 98985 },
    { name: 'Ink - Sepolia', chainId: 763373 },
    // { name: 'Mint - Testnet', chainId: 1686 },


    // { name: 'Orenium Testnet Protocol', chainId: 8890 },


    // { name: 'Metis - Testnet Goerli', chainId: 599 },
    // { name: 'Neon EVM - Testnet Devnet', chainId: 245022926 },

    

    // { name: 'zkSync ERA - Testnet', chainId: 280 },

  ],
  toChainId: -2,
  selectedToken: {},
  selectedBalance: '0.0',
  tokens: [],
  amount: ''
}
}

const txType = Object.freeze({
MINT: 'mintToBridgeOut', // mint
RELEASE: 'unlockToBridgeIn' // release
})

export default {
mixins: [
  loader,
  utilities
],

data () {
  return {
    ...dataInitialState(),
    isClaimSuccessModalOpen: false,  /////////////////////
    selectedToken: null,
    buttonClicked: false,
    notificationMessage: "",

    isConfirmationModalOpen: false,

    web3: null,
    currentUserAccount: null,
  };
},

async created() {
    // Initialize Web3
    if (window.ethereum) {
      try {
        // Request account access if needed
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        this.web3 = new Web3(window.ethereum);
        // Get current user account
        const accounts = await this.web3.eth.getAccounts();
        this.currentUserAccount = accounts[0];
      } catch (error) {
        console.error('Error initializing Web3:', error);
      }
    } else {
      console.error('Web3 provider not found. Please install MetaMask or other Ethereum provider extension.');
    }
    // Fetch other data...
  },

computed: {
...mapState([
  'chainId',
  'claims',
  'claimedClaims' // Make sure this line is here
]),
shouldDisableBridgeButton() {
  return this.claimedClaims.length !== this.claims.length;
}
},

watch: {
  chainId () {
    this.resetData()
    this.fetchPageData()
  }
},

async mounted () {
  // เพิ่ม event listener สำหรับการแสดง confirm dialog ก่อนรีเฟรช
  window.addEventListener('beforeunload', this.confirmReload)
  // ดึงข้อมูลหน้าเว็บหลังจากเว็บโหลดเสร็จสิ้น
  await this.fetchPageData()
},

beforeDestroy() {
  // ก่อนที่ component จะถูกทำลาย
  window.removeEventListener('beforeunload', this.confirmReload)
},


methods: {
  
  isCurrentUserAccount(receiver) {
      return receiver === this.currentUserAccount;
    },
  openConfirmationModal() {
      this.isConfirmationModalOpen = true;
    },

    closeConfirmationModal() {
      this.isConfirmationModalOpen = false;
    },

    confirmLockOrBurn() {
      this.isConfirmationModalOpen = false;
      // Perform the lockOrBurn action when confirmed
      this.lockOrBurn();
    },



  refreshPage() {
    location.reload(); // รีเฟรชหน้าเว็บโดยไม่ต้องมี confirm
  },

  confirmReload(event) {
      // สร้าง dialog ยืนยันการรีเฟรชหน้าเว็บ / คุณแน่ใจหรือไม่ว่าต้องการรีเฟรชหน้าเว็บ
      event.returnValue = 'Are you sure you want to refresh the page?'
    },
    
  onSelectedTokenChange() {
    this.getBalance();
  },

  isButtonActive(key) {
    const t = this.claims[key];
    return (
      this.chainId == t.sourceChain &&
      (this.chainId == t.targetChain ? this.isSwitchButtonActive : this.isClaimButtonActive)
    );
  },

  openClaimSuccessModal () {
    this.isClaimSuccessModalOpen = true;
  },

  closeClaimSuccessModal () {
    this.isClaimSuccessModalOpen = false;
    this.$router.go(); // Refresh the current route
  },

  resetData: function () {
    Object.assign(this.$data, dataInitialState())
  },
  /* */
  scrollToClaimBridgedTokensSection() {
      // Get the reference to the "Claim Bridged Tokens" section
      const claimBridgedTokensSection = this.$refs.claimBridgedTokensSection;

      // Check if the reference is available
      if (claimBridgedTokensSection) {
        // Scroll to the top of the "Claim Bridged Tokens" section with smooth behavior
        claimBridgedTokensSection.scrollIntoView({ behavior: 'smooth' });
      }
    },

    

  async fetchPageData () {
    this.execWithLoader(async () => {
      this.fromChainData = getChainData(this.chainId)
      this.tokens = await BridgeService.getImportedTokens(this.chainId)
      const wrappedTokens = await BridgeService.getWrappedTokens()
      this.$store.commit('setWrappedTokens', wrappedTokens)

      // add wrapped tokens to the dropdown
      for (const i in wrappedTokens) {
        if (Object.hasOwnProperty.call(wrappedTokens, i)) {
          const wToken = wrappedTokens[i]
          this.tokens.push({
            name: wToken.name,
            symbol: wToken.symbol,
            address: wToken.wrappedToken,
            sourceAddress: wToken.token,
            sourceChainId: wToken.sourceChain
          })
        }
      }
    })
  },

  async getBalance () {
    this.execWithLoader(async () => {
      this.selectedBalance = await WalletService.getTokenBalance(this.selectedToken.address)
    }, 'Get token balance error')
  },

  async lockOrBurn() {
  if (this.buttonClicked) {
    // Button has already been clicked, show a notification
    // this.notificationMessage = "Please claim before proceeding.";
    this.notificationMessage = "Please claim before taking a new bridge..";
    return;
  }

  this.execWithLoader(async () => {
    if (this.chainId === this.selectedToken.chainId) {
      if (this.toChainId === this.selectedToken.chainId) {
        // Show error message or perform desired action
        console.log("To:network cannot be the same as From:network");
        toast.error("To network cannot be the same as From network");
        return;
      }
      await BridgeService.lockToken(this.toChainId, this.selectedToken.address, this.amount);
    } else {
      await BridgeService.burnToken(this.toChainId, this.selectedToken.address, this.amount);
    }

    // Mark the button as clicked
    this.buttonClicked = true;
    // กำหนดข้อความเมื่อ ปุ่ม Next ทำธุรกรรมสำเร็จ
    // this.notificationMessage = "Transaction completed successfully"; 
    this.notificationMessage = "👇 Please get your rights completed. to the destination chain Before going up the new bridge.,   Limitations and cautions - Do not refresh the web page - Cannot recover data or view - Claim only once."; 
    this.scrollToClaimBridgedTokensSection();  /* */
  }, 'Error bridging token');
},

  async mintOrRelease (claimId) {
    this.execWithLoader(async () => {
      const claim = this.claims[claimId]
      if (claim.targetChain === this.chainId) {
        if (claim.type === txType.MINT) {
          await BridgeService.mintToken(claim)
          
        } else { // type is release
          await BridgeService.releaseToken(claim)
        }

        this.claimedClaims.push(claimId)
        // Open the success modal
        this.openClaimSuccessModal();

        // After the logic is successful, scroll to the top of the page
        window.scrollTo({ top: 0, behavior: 'smooth' });
        
      } else { // prompt MM to switch network
        const targetChain = getChainData(claim.targetChain)
        const hexTargetChainId = ethers.utils.hexStripZeros(targetChain.chain_id)
        // Check if MetaMask is installed
        // MetaMask injects the global API into window.ethereum
        if (window.ethereum) {
          try {
          // check if the chain to connect to is installed
            await window.ethereum.request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId: hexTargetChainId }] // chainId must be in hexadecimal numbers
            })
          } catch (error) {
            console.log(error)
            // This error code indicates that the chain has not been added to MetaMask
            // if it is not, then install it into the user MetaMask
            if (error.code === 4902) {
              try {
                await window.ethereum.request({
                  method: 'wallet_addEthereumChain',
                  params: [
                    {
                      chainId: '',
                      rpcUrl: ''
                    }
                  ]
                })
              } catch (addError) {
                console.error(addError)
              }
            }
            console.error(error)
          }
        } else {
        // if no window.ethereum then MetaMask is not installed
          alert('MetaMask is not installed. Please consider installing it: https://metamask.io/download.html')
        }
      }
    }, 'Claiming token failed')
  }
}

}
</script>